import request from '@/utils/request';
import { auditEndpoint } from '@/constants/urls';

const audits = (
  category,
  code,
  {
    when,
    who,
    as,
    what,
    entity,
  },
  page,
  pageSize,
  orderBy,
) => {
  const params = {
    page,
    pageSize,
    what,
    as,
    when,
    userName: who,
  };

  if (!code) {
    params.primaryEntity = entity;
  }

  if (orderBy) {
    params.orderBy = orderBy;
  }

  return (
    request({
      url: auditEndpoint(category, code),
      params,
      method: 'GET',
    })
  );
};

const AuditService = {
  audits,
};

export default AuditService;
